import {call, put, all, takeLatest} from "redux-saga/effects";
import {
    GET_LEGS,
    GET_LEGS_SUCCESS,
    ADD_LEG,
    GET_SINGLE_TRIP_SUCCESS,
    GET_SINGLE_TRIP,
    REPEAT_WEEKLY,
    EDIT_TRIP,
    DELETE_TRIP,
    CANCEL_TRIP,
    DELETE_LEG,
    CANCEL_LEG,
    GET_LEGS_TOTAL_SUCCESS,
    GET_LEGS_TOTAL,
    LEG_ASSIGN_OR_CHANGE_DATA,
    ACCEPT_PENDING_LEG,
    REJECT_PENDING_LEG,
    RECALCULATE_TRIP_REVENUE,
    OVERRIDE_TRIP_LOS,
    REFRESH_ALL_DATA,
    LEG_CSV_IMPORT,
    LEG_CSV_IMPORT_SUCCESS,
    UN_CANCEL_LEG, CREATE_LEG_NOTE, EDIT_LEG_NOTE, DELETE_LEG_NOTE, UN_CANCEL_TRIP, NO_SHOW_LEG, UN_NO_SHOW_LEG,
    GET_PATIENT_TRIPS, GET_PATIENT_TRIPS_SUCCESS,
} from "./legs.types";
import {httpRequestsOnErrorsActions} from "../http_requests_on_errors";
import {httpRequestsOnLoadActions} from "../http_requests_on_load";
import {httpRequestsOnSuccessActions} from "../http_requests_on_success";
import {legsService} from "./legs.service";
import {legsActions} from "./index";
import {vehiclesActions} from "../vehicles";
import {vehiclesService} from "../vehicles/vehicles.service";
import {GET_VEHICLES_LOCATIONS_SUCCESS} from "../vehicles/vehicles.types";
import {noteService} from "../notes/note.service";
import {GET_GLOBAL_NOTES} from "../notes/note.type";

function* getLegs({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(
            legsService.getLegsService,
            payload?.params,
        );

        yield put({
            type: GET_LEGS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put({
            type: GET_LEGS_SUCCESS,
            payload: null,
        });

        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        if (!payload?.noLoad) {
            yield put(httpRequestsOnLoadActions.removeLoading(type));
        }
    }
}

function* getPatientTrips({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(
            legsService.getLegsService,
            payload?.params,
        );

        yield put({
            type: GET_PATIENT_TRIPS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put({
            type: GET_PATIENT_TRIPS_SUCCESS,
            payload: null,
        });

        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        if (!payload?.noLoad) {
            yield put(httpRequestsOnLoadActions.removeLoading(type));
        }
    }
}

function* fetchLegsData(requestParams) {
    try {
        const res = yield call(legsService.getLegsService, requestParams);
        yield put({type: GET_LEGS_SUCCESS, payload: res.data});
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(GET_LEGS, err?.data?.message));
    }
}

function* fetchSingleTripData(id) {
    try {
        const res = yield call(legsService.getSingleTripService, id, {});
        yield put({type: GET_SINGLE_TRIP_SUCCESS, payload: res.data});
    } catch (err) {
        // silent fail
    }
}

function* addLeg({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let addError = null;

    let addRes = null;
    try {
        addRes = yield call(legsService.addLegsService, payload.body);
    } catch (err) {
        addError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!addError) {
        if (addRes?.data) {
            yield put({type: GET_SINGLE_TRIP_SUCCESS, payload: addRes?.data});
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    }

    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* deleteLeg({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let deleteError = null;

    try {
        yield call(legsService.deleteLegService, payload.id, payload.params);
    } catch (err) {
        deleteError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!deleteError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        if (payload?.tripId) yield call(fetchSingleTripData, payload.tripId);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* cancelLeg({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let cancelError = null;

    try {
        yield call(legsService.cancelLegService, payload.id, payload.params);
    } catch (err) {
        cancelError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!cancelError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        if (payload?.tripId) yield call(fetchSingleTripData, payload.tripId);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* unCancelLeg({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let unCancelError = null;

    try {
        yield call(legsService.unCancelLegService, payload.id, payload.params);
    } catch (err) {
        unCancelError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!unCancelError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        if (payload?.tripId) yield call(fetchSingleTripData, payload.tripId);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}


function* noShowLeg({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let noShowError = null;

    try {
        yield call(legsService.noShowLegService, payload.id, payload.params);
    } catch (err) {
        noShowError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!noShowError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        if (payload?.tripId) yield call(fetchSingleTripData, payload.tripId);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* unNoShowLeg({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let unNoShowError = null;

    try {
        yield call(legsService.unNoShowLegService, payload.id, payload.params);
    } catch (err) {
        unNoShowError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!unNoShowError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        if (payload?.tripId) yield call(fetchSingleTripData, payload.tripId);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}


function* legAssignOrChangeData({ payload, type }) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let assignError = null;

    try {
        yield call(
            legsService.legAssigneeOrChangeDataService,
            payload?.id,
            payload?.body
        );
    } catch (err) {
        assignError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!assignError && !payload?.noSuccess) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    }

    yield put(httpRequestsOnLoadActions.removeLoading(type));
}


function* acceptPendingLegs({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(legsService.acceptPendingLegsService, payload.body);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* rejectPendingLegs({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(legsService.rejectPendingLegsService, payload.body);

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* getLegsTotals({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(
            legsService.getLegsTotalsService,
            payload?.params,
        );

        yield put({
            type: GET_LEGS_TOTAL_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        if (!payload?.noLoad) {
            yield put(httpRequestsOnLoadActions.removeLoading(type));
        }
    }
}

function* getSingleTrip({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(
            legsService.getSingleTripService,
            payload?.id, payload?.params,
        );

        yield put({
            type: GET_SINGLE_TRIP_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}


function* editTrip({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let editError = null;
    try {
        yield call(legsService.editTripService, payload.id, payload.body);
    } catch (err) {
        editError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!editError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield call(fetchSingleTripData, payload.id);
    }

    yield put(httpRequestsOnLoadActions.removeLoading(type));
}


function* deleteTrip({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let deleteError = null;

    try {
        yield call(legsService.deleteTripService, payload.id, payload.params);
    } catch (err) {
        deleteError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!deleteError) yield put(httpRequestsOnSuccessActions.appendSuccess(type));
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}


function* cancelTrip({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let cancelError = null;

    try {
        yield call(legsService.cancelTripService, payload.id, payload.params);
    } catch (err) {
        cancelError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!cancelError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield call(fetchSingleTripData, payload.id);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* unCancelTrip({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let unCancelError = null;
    try {
        yield call(legsService.unCancelTripService, payload.id, payload.params);
    } catch (err) {
        unCancelError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
    }

    yield call(fetchLegsData, payload?.requestParams);

    if (!unCancelError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield call(fetchSingleTripData, payload.id);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* recalculateTripRevenue({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(legsService.recalculateTripRevenue, payload.id, payload.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

        yield put({
            type: GET_SINGLE_TRIP,
            payload: {
                id: payload.id,
                noLoad: true,
            },
        });
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* overrideTripLos({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));

    let overrideError = null;

    try {
        yield call(legsService.overrideTripLosService, payload.id, payload.body);
    } catch (err) {
        overrideError = err;
        yield put(httpRequestsOnErrorsActions.appendError(type, err?.data?.message));
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }

    if (payload?.requestParams) {
        yield call(fetchLegsData, payload?.requestParams);
    }

    if (!overrideError) {
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield call(fetchSingleTripData, payload.id);
    }
    yield put(httpRequestsOnLoadActions.removeLoading(type));
}

function* refreshAllData({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const [legsData, totals] = yield all([
            call(legsService.getLegsService, payload?.params),
            call(legsService.getLegsTotalsService, {serviceDate: payload?.params?.serviceDate}),
        ]);

        if (payload?.mapView) {
            const vehicleLoc = yield call(vehiclesService.getVehiclesLocationsService);
            yield put({type: GET_VEHICLES_LOCATIONS_SUCCESS, payload: vehicleLoc?.data})
        }

        yield put({type: GET_LEGS_SUCCESS, payload: legsData.data});
        yield put({type: GET_LEGS_TOTAL_SUCCESS, payload: totals.data});

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}


/** Repeat weekly */
function* repeatWeekly({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(legsService.repeatWeeklyService, payload.body);
        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/** CSV */
function* uploadLegCsv({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        const res = yield call(legsService.uploadLegCsv, payload?.file, payload?.type);

        yield put({
            type: LEG_CSV_IMPORT_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));

    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

/** End */

/** Notes */

function* creteLegNote(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(legsService.createLegNoteService, action.payload.legId, action.payload.body);
        yield put(legsActions.getSingleTrip(action.payload?.tripId, {}, true));

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(
            httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message),
        );
    }
}

function* editLegNote(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            legsService.editLegNoteService,
            action.payload.legId,
            action.payload.noteId,
            action.payload.body,
            action.payload.tripId,
        );
        yield put(legsActions.getSingleTrip(action.payload?.tripId, {}, true));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(
            httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message),
        );
    }
}

function* deleteLegNote(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(legsService.deleteLegNoteService, action.payload.legId, action.payload.noteId);

        yield put(legsActions.getSingleTrip(action.payload?.tripId, {}, true));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(
            httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message),
        );
    }
}

/** End */

export const watchLegs = function* watchLegs() {
    yield takeLatest(GET_LEGS, getLegs);
    yield takeLatest(GET_PATIENT_TRIPS, getPatientTrips);
    yield takeLatest(ADD_LEG, addLeg);
    yield takeLatest(DELETE_LEG, deleteLeg);
    yield takeLatest(CANCEL_LEG, cancelLeg);
    yield takeLatest(UN_CANCEL_LEG, unCancelLeg);
    yield takeLatest(NO_SHOW_LEG, noShowLeg);
    yield takeLatest(UN_NO_SHOW_LEG, unNoShowLeg);
    /** Notes Leg */
    yield takeLatest(CREATE_LEG_NOTE, creteLegNote);
    yield takeLatest(EDIT_LEG_NOTE, editLegNote);
    yield takeLatest(DELETE_LEG_NOTE, deleteLegNote);
    /** End */

    yield takeLatest(ACCEPT_PENDING_LEG, acceptPendingLegs);
    yield takeLatest(REJECT_PENDING_LEG, rejectPendingLegs);

    yield takeLatest(LEG_ASSIGN_OR_CHANGE_DATA, legAssignOrChangeData);
    yield takeLatest(GET_LEGS_TOTAL, getLegsTotals);

    /** TRIP */
    yield takeLatest(GET_SINGLE_TRIP, getSingleTrip);
    yield takeLatest(EDIT_TRIP, editTrip);
    yield takeLatest(DELETE_TRIP, deleteTrip);
    yield takeLatest(RECALCULATE_TRIP_REVENUE, recalculateTripRevenue);
    yield takeLatest(OVERRIDE_TRIP_LOS, overrideTripLos);
    yield takeLatest(CANCEL_TRIP, cancelTrip);
    yield takeLatest(REFRESH_ALL_DATA, refreshAllData);
    yield takeLatest(UN_CANCEL_TRIP, unCancelTrip);

    /** Repeat weekly */
    yield takeLatest(REPEAT_WEEKLY, repeatWeekly);

    /** CSV */
    yield takeLatest(LEG_CSV_IMPORT, uploadLegCsv);
    /** End */
};
